(function($){
    "use strict";

    let slickInitialized = false;
    let resizeTimer = null;

    let slickInitializedProjects = false;
    let resizeTimerProjects = null;

    function initGallery() {
        const $slider = $('.studio-block-list-slider');

        if ($(window).width() > 991) {

            if (!slickInitialized) {

                $slider.slick({
                    dots: true,
                    infinite: true,
                    speed: 300,
                    fade: false,
                    cssEase: 'linear',
                    slidesToScroll: 1,
                    arrows: true,
                    autoplay: false,
                    autoplaySpeed: 3000,
                    centerMode: true,
                    variableWidth: true,
                    appendDots: $('.studio-block-list-nav')
                });

                let scrolling = false;

                $slider.on('wheel.slickScroll', function(e) {
                    e.preventDefault();
                    if (scrolling) {
                        return;
                    }
                    scrolling = true;
                    if (e.originalEvent.deltaY < 0) {
                        $slider.slick('slickPrev');
                    } else {
                        $slider.slick('slickNext');
                    }
                    setTimeout(() => scrolling = false, 300);
                });

                slickInitialized = true;
            }

        } else {
            if (slickInitialized || $slider.hasClass('slick-initialized')) {
                $slider.off('wheel.slickScroll');
                $slider.slick('unslick');
                slickInitialized = false;
            }
        }
    }


    function initProjects() {
        const $slider = $('.projects-list');

        // Desktop mode
        if ($(window).width() > 1199) {

            if (!slickInitializedProjects) {

                $slider.slick({
                    dots: true,
                    infinite: true,
                    speed: 300,
                    fade: false,
                    cssEase: 'linear',
                    slidesToScroll: 1,
                    arrows: true,
                    autoplay: false,
                    autoplaySpeed: 3000,
                    centerMode: false,
                    variableWidth: true,
                    appendDots: $('.studio-block-list-nav')
                });

                let scrolling = false;

                $slider.on('wheel.slickScroll', function (e) {
                    e.preventDefault();
                    if (scrolling) {
                        return;
                    }
                    scrolling = true;
                    if (e.originalEvent.deltaY < 0) {
                        $slider.slick('slickPrev');
                    } else {
                        $slider.slick('slickNext');
                    }
                    setTimeout(() => scrolling = false, 350);
                });

                slickInitializedProjects = true;
            }

        } else {
            if (slickInitializedProjects || $slider.hasClass('slick-initialized')) {
                $slider.off('wheel.slickScroll');
                $slider.slick('unslick');
                slickInitializedProjects = false;
            }
        }
    }


    function gallery() {
        if (resizeTimer) {
            clearTimeout(resizeTimer);
        }
        resizeTimer = setTimeout(function() {
            initGallery();
        }, 150);
    }

    function projects() {
        if (resizeTimerProjects) {
            clearTimeout(resizeTimerProjects);
        }
        resizeTimerProjects = setTimeout(function() {
            initProjects();
        }, 150);
    }

    function menu(){
        jQuery(".site-header .mobile-menu").click(function(e){
            e.preventDefault();
            jQuery("body").toggleClass('active-menu');
        });
    }


    $(document).ready(function () {
        menu();
        gallery();
        projects();

        $(window).scroll(function () {
            const header = $('body');
            const scroll = $(window).scrollTop();
            if (scroll >= 35) {
                header.addClass('sticky');
            } else {
                header.removeClass('sticky');
            }
        });

        /*let resizeTimer;

        $(window).on('resize', function () {
            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(() => {
                gallery();
                projects();
            }, 150);
        });*/

        $(window).on('resize', function () {
            gallery();
            projects();
        });
    });

})(jQuery);
